// header的項目
// 只存 i18n key，不要在這裡直接呼叫 getI18nTranslate 解析文字：這個陣列是模組載入時
// 只會建立一次的純陣列，main.ts 不會等 loadLocaleMessages() 載完語系檔就先 mount，
// 若這個模組剛好比語系檔先載入，解析出來的文字會是還沒翻譯的 i18n key，而且永遠不會
// 再重新計算，整個分頁期間都卡在錯誤的文字。實際翻譯交給 useHeader.ts 在每次路由切換
// 當下才呼叫 getI18nTranslate，這時候語系檔必定已經載完。
export const headerTitleList = [
  {
    name: 'Home',
    'header-title-key': ''
  },
  {
    name: 'Profile',
    'header-title-key': 'ProfilePage.HeaderTitle'
  },
  {
    name: 'Member',
    'header-title-key': 'MemberPage.HeaderTitle'
  },
  {
    name: 'MemberInfo',
    'header-title-key': 'MemberInfoPage.HeaderTitle'
  },
  {
    name: 'AddMember',
    'header-title-key': 'AddMemberPage.HeaderTitle'
  },
  {
    name: 'InviteLink',
    'header-title-key': 'InviteLinkPage.HeaderTitle'
  },
  {
    name: 'GroupEdit',
    'header-title-key': 'GroupEditPage.HeaderTitle'
  },
  {
    name: 'Product',
    'header-title-key': 'ProductPage.HeaderTitle'
  },
  {
    name: 'FeeDetails',
    'header-title-key': 'FeeDetailsPage.HeaderTitle'
  },
  {
    name: 'PaymentRecords',
    'header-title-key': 'PaymentRecordsPage.HeaderTitle'
  },
  {
    name: 'PaymentOptions',
    'header-title-key': 'PaymentOptionsPage.HeaderTitle'
  },
  {
    name: 'PaymentConfirmation',
    'header-title-key': 'PaymentConfirmationPage.HeaderTitle'
  }
]
